<div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; height: 100%; ">
  <!--- Limited User --->
  <div *inRole="[roles.LimitedFeatureSet]" style="height: 100%;">
    <iframe *ngIf="url$ | async as url; else no_pdf_limited_template" style="height: 100%; width: 100%;"
      [src]="url | safeResourceUrl" [ngClass]="{'disable-mouse-events' : isContextPanelResizing}"></iframe>
    <ng-template #no_pdf_limited_template>
      <div style="display: flex; flex-direction: row; justify-content: center; align-items: center; margin: 5px;">
        No Annotated Pdf Available
      </div>
    </ng-template>
  </div>
  <!-- End Limited User -->
  <div *inRole="[roles.LimitedFeatureSet]; negative: true"
    style="display: flex; flex-direction: column; overflow: auto; height: 100%;" class="content">
    <ng-container *ngIf="showAnnotatedPdf; else editor_template">
      <iframe *ngIf="url$ | async as url; else no_pdf_template" style="height: 100%; width: 100%;"
      [src]="url | safeResourceUrl" [ngClass]="{'disable-mouse-events' : isContextPanelResizing}"></iframe>
    <ng-template #no_pdf_template>
      <div style="display: flex; flex-direction: row; justify-content: center; align-items: center; margin: 5px;">
        No Annotated Pdf Available
      </div>
    </ng-template>
    </ng-container>
    <ng-template #editor_template>
      <ng-container *ngIf="editorMode$ | async as editorMode">
        <div *ngIf="(editorMode === 'annotate-images') && editImageSource" style="justify-content: center;">
          <div *ngIf="pages$ | async as pages"
            style="display: flex; flex-direction: row; justify-content: center; align-items: center; margin: 5px; padding: 8px;">
            <div style="display:flex; flex-direction:row; align-items: center; gap: 4px;">
              <button (click)="goToPage(currentPageNumber - 1)"
                [disabled]="pages.length <= 1 || currentPageNumber === 1" matTooltip="Previous Page"
                [style.cursor]="currentPageNumber !== 1 ? 'pointer' : 'default'"
                style="display: flex; border: unset; font-size: 16px !important; background-color: inherit;">
                <i class="fa-duotone fa-angle-left"
                  [ngClass]="{'button-icon': currentPageNumber !== 1, 'button-disabled': currentPageNumber === 1}"></i>
              </button>
              <div>
                <div #pageMenuSelector style="display:flex; align-items: center; gap: 4px;">
                  <div style="align-self: center;">Page</div>
                  <div style="text-wrap: nowrap;">
                    {{currentPageDisplayValue}}
                  </div>
                  <div *ngIf="pages?.length > 1" [matMenuTriggerFor]="pageSelect" style="cursor: pointer;"
                    (menuOpened)="pageMenuOpened()">
                    <i class="fa-duotone fa-caret-down"></i>
                  </div>
                  <div>of</div>
                  <div style="align-self: center;">{{pages?.length}}</div>
                </div>
              </div>
              <button (click)="goToPage(currentPageNumber + 1)"
                [disabled]="pages.length <= 1 || pages.length === currentPageNumber" matTooltip="Next Page"
                [style.cursor]="currentPageNumber < pages?.length ? 'pointer' : 'default'"
                style="display: flex; border: unset; font-size: 16px !important; background-color: inherit;">
                <i class="fa-duotone fa-angle-right"
                  [ngClass]="{'button-icon': currentPageNumber < pages?.length, 'button-disabled': currentPageNumber >= pages?.length}"></i>
              </button>
              <mat-menu class="doc-viewer-menu" #pageSelect yPosition="below" xPosition="before">
                <cdk-virtual-scroll-viewport itemSize="48" style="min-width: 100%;"
                  [style.height.px]="pages?.length > 5 ? 240 : pages?.length * 48"
                  [style.width.px]="pageMenuSelector.clientWidth">
                  <menu mat-menu-item *cdkVirtualFor="let page of pages; index as i;"
                    [ngClass]="{'selected':currentPageNumber === i + 1}" (click)="goToPage(i + 1)">
                    <div>{{page}}</div>
                  </menu>
                </cdk-virtual-scroll-viewport>
              </mat-menu>
            </div>
          </div>
        </div>
        <div *ngIf="editorMode === 'annotate-images' && editImageSource" id="annotation-edit-zone"
          style="overflow: auto; margin: auto; max-width: 100%; position: relative">
          <lex-draw-box [canvasWidth]="annotationEditorImage?.nativeElement.width"
            [canvasHeight]="annotationEditorImage?.nativeElement.height" [edits]="currentEdits" [mode]="'annotation'"
            (editsChanged)="updateEdits($event)"></lex-draw-box>
          <img id="annotation-edit-image" style="cursor:crosshair" class="disable-select disable-drag"
            *ngIf="editImageSource" [src]="editImageSource | safeResourceUrl" #annotationEditorImage />
        </div>
        <div *ngIf="editorMode === 'generate-images'"
          style="overflow: auto; margin: auto; max-width: 100%; position: relative">
          <div class="paper-sized-card">
            <lex-flat-button label="Generate Images" (click)="requestImageGeneration()"></lex-flat-button>
          </div>
        </div>
        <div *ngIf="editorMode === 'loading'" style="overflow: auto; margin: auto; max-width: 100%; position: relative">
          <div *ngIf="true" class="loading-status">
            <mat-spinner strokeWidth="2" diameter="60"></mat-spinner>
          </div>
        </div>
      </ng-container>
    </ng-template>
  </div>
</div>